var _path, _path2, _path3, _circle, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackupcodesDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 93,
    viewBox: "0 0 64 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.05 34.9068C56.05 34.9068 56.0865 15.1059 37.5265 9.73964C37.5265 9.73964 17.7639 4.72121 8.44881 19.5966L2.84937 16.8702L7.37245 31.5511L21.7322 26.6872L17.6187 24.3106C17.6187 24.3106 22.6653 16.241 36.0195 19.8065C36.0195 19.8065 45.9275 22.9522 46.5737 34.9068",
    fill: "#266ACA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.05 34.9068C56.05 34.9068 56.0865 15.1059 37.5265 9.73964C37.5265 9.73964 17.7639 4.72121 8.44881 19.5966L2.84937 16.8702L7.37245 31.5511L21.7322 26.6872L17.6187 24.3106C17.6187 24.3106 22.6653 16.241 36.0195 19.8065C36.0195 19.8065 45.9275 22.9522 46.5737 34.9068",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.84937 36.144C2.84937 36.144 2.81292 56.8878 21.3727 62.5096C21.3727 62.5096 41.1351 67.767 50.4501 52.1833L56.05 55.0395L51.527 39.6595L37.1674 44.7551L41.2808 47.2448C41.2808 47.2448 36.2343 55.6987 22.8802 51.9634C22.8802 51.9634 12.9723 48.6679 12.3261 36.144",
    stroke: "#2EA76D",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 17.5,
    r: 13.5,
    fill: "#D0021B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 46.1633,
    y: 24.9033,
    width: 2.9299,
    height: 16.6028,
    rx: 1,
    transform: "rotate(-135 46.1633 24.9033)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44.0916,
    y: 13.1633,
    width: 2.9299,
    height: 16.6028,
    rx: 1,
    transform: "rotate(-45 44.0916 13.1633)",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackupcodesDelete);
export default __webpack_public_path__ + "static/media/backupcodes-delete.fa65ff358ee8c04c3440711fb150c624.svg";
export { ForwardRef as ReactComponent };